import { ConfirmationMsgVisibleReferer, getNumberOfFreePlugins } from '../../../domain/free-plugin-provider';
import { plural } from '../free-plugin-box';
import CircledCheckIcon from '../../../../../../ui/svg/common/check-v-circled';
import TermsAndConditions from '../../shared/terms-and-conditions';
import FreePluginProgressBarWithMilestones from './free-plugin-progress-milestones';
import { ICartData } from '../../../interfaces';
import { isFreePluginsBoxWithMilestoneVisible } from '../../../domain/free-plugin-milestones-provider';

interface IFreePluginBoxMilestonesProps {
    cartData: ICartData;
    classes?: string;
    referrer: ConfirmationMsgVisibleReferer;
    cartStep: number;
}

const FreePluginBoxMilestones = ({ cartData, referrer, classes, cartStep }: IFreePluginBoxMilestonesProps) => {
    const numberOfFreePlugins = getNumberOfFreePlugins(cartData);
    const visibility = isFreePluginsBoxWithMilestoneVisible(cartData, referrer, cartStep);
    const isVisible = visibility?.addMoreEnabled || visibility?.progressBarEnabled;

    if(!isVisible) return null;

    return (
        <div className={ `text-gray-700 border border-green rounded bg-green-100 px-3 py-3 flex flex-col ${ classes ?? '' }` } role="alert">
            <>
                {
                    visibility.addMoreEnabled &&
                    <div className="flex items-center gap-2">
                        <CircledCheckIcon
                            width="24"
                            height="24"
                            bgColor="#00BA90"
                        />

                        <div>
                            <p
                                style={{
                                    letterSpacing: '-0.2px',
                                }}
                                className="font-bold md:whitespace-nowrap">
                                Your cart is eligible for { numberOfFreePlugins } free { plural('plugin', numberOfFreePlugins) }.
                            </p>

                            <p
                                style={{
                                    letterSpacing: '-0.1px',
                                }}
                                className="text-xs">
                                An email to select { numberOfFreePlugins === 1 ? 'it' : 'them' } will be sent after checkout.
                            </p>
                        </div>
                    </div>
                }
            </>

            {
                visibility.progressBarEnabled &&
                <FreePluginProgressBarWithMilestones
                    cartData={ cartData }
                    classes={ visibility.addMoreEnabled ? 'mt-4' : '' }
                />
            }

            {
                (!visibility.progressBarEnabled || visibility.showTCLinkSeparately) &&
                <div className="flex items-center gap-4">
                    <div className="flex-1">&nbsp;</div>
                    <p>
                        <TermsAndConditions url={ cartData.efstcurl } />
                    </p>
                </div>
            }
        </div>
    )
};

export  default FreePluginBoxMilestones;